export const setIds = (state, trackers) => {
  state.trackers = trackers
}
